const themeMain = "#e7354b"; //red
const themePrimary = "#0e80f8"; //blue
const themeSuccess = "#4db78e"; //green
const themeWarning = "#f1c346"; //yellow

const textMain = "#222222"; //Text greyish Black
const textSecondary = "rgb(102, 102, 102)"; //text light grey
const textWhite = "white";
const textPrimary = themePrimary; //blue
const textSuccess = themeSuccess; //green
const textWarning = themeWarning; //yellow

const bgDark = "#212435"; //darkBlue
const bgSecondary = "#f2f2f2"; //greyishBackground
const bgWhite = "white";
const bgMain = themeMain; //red
const bgPrimary = themePrimary; //blue
const bgSuccess = themeSuccess; //green
const bgWarning = themeWarning; //yellow

const colors = {
	themeMain,
	themePrimary,
	themeSuccess,
	themeWarning,
	textMain,
	textSecondary,
	textWhite,
	textPrimary,
	textSuccess,
	textWarning,
	bgDark,
	bgSecondary,
	bgWhite,
	bgPrimary,
	bgSuccess,
    bgWarning,
    bgMain,
};

export default colors